export default __webpack_public_path__ + "static/Order-Management-0c431f41fbdb81c05c019a6477647531.webp";